'use strict';

const swiper = new Swiper(".swiper", {
  direction: "horizontal",
  loop: true,
  effect: 'flip',
  limitRotation: true,
  slideShadows: true,
  speed: 800,

   // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

    pagination: {
    el: '.swiper-pagination',
  },

});

class ItcAccordion {
  #el;
  #config;

  constructor(target, config) {
    this.#el = typeof target === 'string' ? document.querySelector(target) : target;
    const defaultConfig = {
      alwaysOpen: true
    };
    this.#config = Object.assign(defaultConfig, config);
    if (this.#el) {
      this.addEventListener();
    } else {
      console.warn('ItcAccordion: Target element not found.');
    }
  }

  addEventListener() {
    this.#el.addEventListener('click', (e) => {
      const elHeader = e.target.closest('.accordion__header');
      if (!elHeader) return;

      const elItem = elHeader.parentElement;
      const isOpen = elItem.classList.contains('accordion__item_show');

      if (!this.#config.alwaysOpen) {
        const elOpenItem = this.#el.querySelector('.accordion__item_show');
        if (elOpenItem && elOpenItem !== elItem) {
          elOpenItem.classList.remove('accordion__item_show');
        }
      }

      elItem.classList.toggle('accordion__item_show', !isOpen);
    });
  }
}

// export default ItcAccordion;

// import ItcAccordion from './index.js';
new ItcAccordion('.accordion', { alwaysOpen: false });